import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {LoaderService} from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  isLoading: any;

  constructor(private loaderService: LoaderService, private ref: ChangeDetectorRef,) {
    this.loaderService.isLoading.subscribe((res => {

      this.isLoading = res;
      this.ref.markForCheck();
      this.ref.detectChanges();
    }));

  }

  ngOnInit(): void {
    /**/
  }

}
